module.exports = __webpack_public_path__ + "static/img/fm10.117915c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fm10.jpg
// module id = YBwU
// module chunks = 1